import React, { useEffect, useState } from "react";
// import {
//   useCollectionData,
//   useCollectionDataOnce,
// } from "react-firebase-hooks/firestore";
import {
  // subdomainsCollection,
  useData,
  // usersCollection,
  // phoneCollection,
} from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
// import Circle from "../../../components/appLoading/circle";
//material
// import TreeView from "@material-ui/lab/TreeView";
import Typography from "@material-ui/core/Typography";
// import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
// import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import ChevronRightIcon from "@material-ui/icons/ChevronRight";
// import TreeItem from "@material-ui/lab/TreeItem";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import SmsOutlinedIcon from "@material-ui/icons/SmsOutlined";
import useStyles from "./style";
import { Avatar } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import size from "lodash/size";

function PohonJaringan() {
  const classes = useStyles();
  const { profil } = useData();
  const [data, setData] = useState([]);

  useEffect(() => {
    const getActiveDownline = firefunctions.httpsCallable("getActiveDownline");

    getActiveDownline({ user_id: profil.id }).then((res) => {
      setData([
        {
          nama: profil.nama,
          tipe_akun: profil.tipe_akun,
          user_id: profil.id,
          children: res.data,
        },
      ]);
    });

    return () => {
      setData([]);
    };
  }, []);

  const handleMessage = (no, nama) => {
    const text = `halo kak ${nama}, apa kabar nih? semoga sehat selalu.`;
    window.open(`https://api.whatsapp.com/send?phone=${no}&text=${text}`);
  };

  const tipeAkun =
    profil.tipe_akun === "distributor"
      ? "agen"
      : profil.tipe_akun === "agen"
      ? "reseller"
      : profil.tipe_akun === "mentorbisnis"
      ? "distributon"
      : "";
  if (data.length === 0) {
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "3%",
          }}
        >
          <div
            style={{
              display: "flex",
              marginLeft: "1.5%",
              width: "60%",
            }}
          >
            <Avatar className={classes.medium}>
              <Skeleton
                variant="circle"
                style={{
                  width: 50,
                  height: 50,
                }}
              />
            </Avatar>
            <div style={{ marginLeft: "1.5%", width: "200px" }}>
              <div style={{ width: "80%" }}>
                <Skeleton variant="text" />
              </div>
              <div style={{ width: "100%" }}>
                <Skeleton variant="text" />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "40%",
              // marginRight: "1,5%",
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100px", marginRight: "5%" }}>
              <Skeleton variant="text" />
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "3%",
          }}
        >
          <div
            style={{
              display: "flex",
              marginLeft: "1.5%",
              width: "60%",
            }}
          >
            <Avatar className={classes.medium}>
              <Skeleton
                variant="circle"
                style={{
                  width: 50,
                  height: 50,
                }}
              />
            </Avatar>
            <div style={{ marginLeft: "1.5%", width: "200px" }}>
              <div style={{ width: "80%" }}>
                <Skeleton variant="text" />
              </div>
              <div style={{ width: "100%" }}>
                <Skeleton variant="text" />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "40%",
              // marginRight: "1,5%",
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100px", marginRight: "5%" }}>
              <Skeleton variant="text" />
            </div>
          </div>
        </div>
      </div>
    );
  }
  // console.log(data?.[0]?.children.length);
  return (
    <>
      {/* {data.map((node) => {
        let newData = data[0].children;
        let nameLevel = "";
        let nilai = 0;

        newData.map((item) => {
          if (profil.id == node.user_id) {
            if (node.tipe_akun === "mentorbisnis") {
              if (item.tipe_akun === "distributor") {
                nameLevel = item.tipe_akun;
                nilai++;
              }
            }
            if (node.tipe_akun === "distributor") {
              if (item.tipe_akun === "agen") {
                nameLevel = item.tipe_akun;
                nilai++;
              }
            }
            if (node.tipe_akun === "agen") {
              if (item.tipe_akun === "reseller") {
                nameLevel = item.tipe_akun;
                nilai++;
              }
            }
          }
        });

        if (data.length === 0) {
          return (
            <div>
              <Circle />
            </div>
          );
        }

        return ( */}
      <div>
        {data[0]?.children?.length !== 0 ? (
          <>
            <div style={{ paddingLeft: "20px" }}>
              <Typography
                noWrap={true}
                style={{
                  fontSize: 12,
                  color: "#777777",
                  textTransform: "capitalize",
                }}
              >
                total {tipeAkun} : {size(data[0]?.children)}
              </Typography>
            </div>
            {data[0]?.children?.map((item, index) => {
              if (index < 3) {
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      marginTop: "2%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "1.5%",
                        width: "70%",
                      }}
                    >
                      <Avatar className={classes.medium}>
                        <AccountCircleIcon style={{ width: 40, height: 40 }} />
                      </Avatar>
                      <div style={{ marginLeft: "1.5%", width: "inherit" }}>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "inline-grid" }}>
                            <Typography
                              noWrap={true}
                              style={{
                                fontSize: 15,
                                fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.nama}
                            </Typography>
                          </div>
                        </div>
                        <div style={{ display: "inline-grid" }}>
                          <Typography
                            noWrap
                            style={{ fontSize: 13, color: "#BCBCBC" }}
                          >
                            {item?.subdomain}.tokorame.store
                          </Typography>
                        </div>
                      </div>
                    </div>
                    {/* <div style={{ marginLeft: "1.5%" }}>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "inline-grid" }}>
                            <Typography
                              noWrap={true}
                              style={{
                                fontSize: 13,
                                // fontWeight: "bold",
                                // textTransform: "capitalize",
                              }}
                            >
                              {item?.hp}
                            </Typography>
                          </div>
                        </div>
                        <div>
                          <Typography color="secondary" style={{ fontSize: 14, color:"#BCBCBC" }}>
                            {item?.tipe_akun}
                          </Typography>
                        </div>
                      </div> */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "50%",
                        // marginRight: "1,5%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "inline-grid" }}>
                            <Typography
                              noWrap={true}
                              style={{
                                fontSize: 13,
                                // fontWeight: "bold",
                                // textTransform: "capitalize",
                              }}
                            >
                              {item?.hp}
                            </Typography>
                          </div>
                        </div>
                        <div>
                          <Typography
                            // color="secondary"
                            style={{
                              fontSize: 12,
                              fontWeight: "bold",
                              // margin: "3px",
                              fontVariant: "small-caps",
                              color: "#f44336",
                              float: "right",
                            }}
                          >
                            {item?.tipe_akun}
                          </Typography>
                        </div>
                      </div>
                      <div
                        style={{
                          marginLeft: "10px",
                          marginRight: "15px",
                          // width: 40,
                          // height: 40,
                        }}
                        onClick={() => handleMessage(item?.hp, item?.nama)}
                      >
                        <SmsOutlinedIcon
                          // style={{ width: 40, height: 40 }}
                          // color="secondary"
                          style={{ color: "#6A6A6A" }}
                        />
                      </div>
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </>
        ) : (
          <Typography
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              marginTop: "2.5%",
              fontWeight: "bold",
            }}
          >
            Tidak Ada Data
          </Typography>
        )}
        {/* <TreeView
              defaultCollapseIcon={<ExpandMoreIcon />}
              defaultExpandIcon={<ChevronRightIcon />}
            >
              <TreeItem
                key={node.user_id}
                nodeId={node.user_id}
                label={
                  <Typography
                    className={classes.liquidBlue}
                  >{`Saya, ${node.nama} (${node.tipe_akun}), Total ${nameLevel} : ${nilai}`}</Typography>
                }
              >
                {Array.isArray(node.children)
                  ? node.children.map((nodes) => {
                      return (
                        <>
                          {" "}
                          <TreeItem
                            key={nodes.user_id}
                            nodeId={nodes.user_id}
                            label={
                              <Typography
                                className={classes.liquidSecondCa}
                              >{`> ${nodes.tipe_akun} : ${nodes.nama} (${nodes.subdomain}) - (${nodes.hp})`}</Typography>
                            }
                          />{" "}
                        </>
                      );
                    })
                  : null}
              </TreeItem>
            </TreeView> */}
      </div>
      {/* );
      })} */}
    </>
  );
}

export default PohonJaringan;
